import { render, staticRenderFns } from "./DashboardLeadStatisticWidget.vue?vue&type=template&id=cf855654&scoped=true"
import script from "./DashboardLeadStatisticWidget.vue?vue&type=script&lang=js"
export * from "./DashboardLeadStatisticWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardLeadStatisticWidget.vue?vue&type=style&index=0&id=cf855654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf855654",
  null
  
)

export default component.exports